import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  fetchStadiumsByFederacion as fetchStadiumsAPI,
          createStadium as createStadiumAPI,
          deleteStadium,
          updateStadium as updateStadiumAPI 
  } from '../../services/estadioService.js';

const initialState = {
  stadiums: [],
  loading: false,
  error: null,
};

const getStadiumId = (stadium) => stadium?.id_estadio ?? stadium?.id;

const mergeUpdatedStadium = (currentStadium, updatedStadium) => {
  if ("id" in currentStadium || "name" in currentStadium) {
    return {
      id: getStadiumId(updatedStadium),
      name: updatedStadium.nombre_estadio ?? updatedStadium.name,
    };
  }

  return updatedStadium;
};

export const createStadium = createAsyncThunk(
  'stadiums/createStadium',
  async (newStadium, { rejectWithValue }) => {
    try {
      const data = await createStadiumAPI(newStadium);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al crear estadio');
    }
  }
);

export const fetchStadiums = createAsyncThunk(
  'stadiums/fetchStadiums',
  async (federacionId, { rejectWithValue }) => {
    try {
      const data = await fetchStadiumsAPI(federacionId);
      return data.map((estadio) => ({
        id: estadio.id_estadio,
        name: estadio.nombre_estadio,
      }));
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al obtener estadios');
    }
  }
);

export const removeStadium = createAsyncThunk(
  'stadiums/removeStadium',
  async (idStadium, { rejectWithValue }) => {
    try {
      const response = await deleteStadium(idStadium);
      return idStadium;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al eliminar el estadio');
    }
  }
);

export const updateStadium = createAsyncThunk(
  'stadiums/updateStadium',
  async ({ idStadium, data }, { rejectWithValue }) => {
    try {
      const response = await updateStadiumAPI(idStadium, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al modificar el estadio');
    }
  }
);

const stadiumsSlice = createSlice({
  name: 'stadiums',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStadiums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStadiums.fulfilled, (state, action) => {
        state.loading = false;
        state.stadiums = action.payload;
      })
      .addCase(fetchStadiums.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createStadium.fulfilled, (state, action) => {
        state.stadiums.push(action.payload);
      })
      .addCase(createStadium.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateStadium.fulfilled, (state, action) => {
        const updatedId = getStadiumId(action.payload);
        const index = state.stadiums.findIndex(
          (stadium) => getStadiumId(stadium) === updatedId
        );
        if (index !== -1) {
          state.stadiums[index] = mergeUpdatedStadium(
            state.stadiums[index],
            action.payload
          );
        }
      });
  },
});

export default stadiumsSlice.reducer;
